import React, { useState } from "react";
import { Tabs, Tab } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import GeneralSettings from "./GeneralSettings";
import AuthenticationSettings from "./AuthenticationSettings";
import ContentSettings from "./ContentSettings";
import LicenceSettings from "./LicenceSettings";
import OrganizationSettings from "./OrganizationSettings";
import EmailSettings from "./EmailSettings";
import FeaturesSettings from "./FeaturesSettings";
import ApiSettings from "./ApiSettings";

const useStyles = makeStyles((theme) => ({
  container: {
    overflow: "auto",
    padding: 20,
    height: "100%",
    flex: 1,
    backgroundColor: "#eae0d7",
    backgroundImage: "url('../../images/background.svg')",
  },
  body: {
    display: "flex",
    height: "100%",
    backgroundColor: "#fff",
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  configContainer: {
    padding: 20,
    width: "100%",
    overflow: "auto",
  },
  tab: {
    textTransform: "none",
  },
}));

function SystemConfiguration() {
  const [selectedTab, setSelectedTab] = useState(0);
  const { t } = useTranslation();
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <div className={classes.body}>
        <Tabs
          value={selectedTab}
          onChange={(_e, nv) => setSelectedTab(nv)}
          orientation="vertical"
          variant="scrollable"
          className={classes.tabs}
        >
          <Tab
            id="general-settings"
            className={classes.tab}
            label={t("settings_general")}
          />
          <Tab
            id="features-settings"
            className={classes.tab}
            label={t("settings_features")}
          />
          <Tab
            id="org-settings"
            className={classes.tab}
            label={t("global_organization")}
          />
          <Tab
            id="licence-settings"
            className={classes.tab}
            label={t("global_licence")}
          />
          <Tab
            id="auth-settings"
            className={classes.tab}
            label={t("settings_authentication")}
          />
          <Tab
            id="content-settings"
            className={classes.tab}
            label={t("global_content")}
          />
          <Tab
            id="email-settings"
            className={classes.tab}
            label={t("settings_email")}
          />
                    <Tab
            id="api-settings"
            className={classes.tab}
            label={t("settings_api")}
          />
        </Tabs>
        <div className={classes.configContainer}>
          {selectedTab === 0 && <GeneralSettings />}
          {selectedTab === 1 && <FeaturesSettings />}
          {selectedTab === 2 && <OrganizationSettings />}
          {selectedTab === 3 && <LicenceSettings />}
          {selectedTab === 4 && <AuthenticationSettings />}
          {selectedTab === 5 && <ContentSettings />}
          {selectedTab === 6 && <EmailSettings />}
          {selectedTab === 7 && <ApiSettings />}
        </div>
      </div>
    </div>
  );
}

export default SystemConfiguration;
